import Api from '../../Api'

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { AsyncCreatable } from 'react-select'
import TextareaAutosize from 'react-autosize-textarea'

class EventCreateRiderRequestModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      description: null,
      selectedUser: undefined,
      error: null
    }

    this.title = React.createRef()
    this.description = React.createRef()
    this.userSelector = React.createRef()
    this.submit = React.createRef()
  }

  componentDidMount() {
    this.title.current.focus()
  }

  getOptions = (input, callback) => {
    if (input.length >= 3) {
      return Api.searchUsers(input)
        .then(response => ({options: response.data.users}))
        .catch(error => ({options: []})) // no search results
    } else {
      callback(null, {
        options: null // search not available
      })
    }
  }

  onSubmit = (e) => {
    e.preventDefault()

    const { title, description, selectedUser } = this.state

    if (!title || !selectedUser) {
      let credentials = 'details'
      credentials = !title ? 'title' : credentials
      credentials = !selectedUser ? 'their email' : credentials
      credentials = !title && !selectedUser ? 'title and their email' : credentials

      this.setState({error: `Please enter rider ${credentials}.`})
    } else {
      this.setState({error: null}, () => this.props.createRiderRequest({title, description, email: this.state.selectedUser.email}))
    }
  }

  render() {
    const { title, description, selectedUser, error } = this.state

    const value = selectedUser

    const descriptionClassName = classnames({
      'textarea-autosize': true,
      'textarea-autosize--focusable': true,
      'description': true,
      'placeholder': !description
    })

    return (
      <div className="modal-content">
        <h3>Ask for a rider</h3>

        <form onSubmit={this.onSubmit}>
          <ul className="group" data-error-msg={error}>
            <li data-title="Title">
              <input ref={this.title}
                type="text"
                className="input--light"
                value={title}
                placeholder="Enter title, such as Avoid Dave"
                onChange={(e) => this.setState({title: e.target.value})} />
            </li>

            <li data-title="Email">
              <div className="select-form">
                <div className="select-form-fields">
                  <AsyncCreatable ref={this.userSelector}
                    cache={false}
                    autoFocus={false}
                    openOnFocus={true}
                    className="select-form-field"
                    value={value}
                    valueKey="id"
                    labelKey="email"
                    clearable={true}
                    placeholder={null}
                    searchPromptText="Type to search or enter a new email"
                    onChange={(selectedUser) => this.setState({selectedUser}, () => this.submit.current.focus())}
                    promptTextCreator={(email) => `Invite "${email}"`}
                    onNewOptionClick={(value) => this.setState({selectedUser: value}, () => this.submit.current.focus())}
                    loadOptions={this.getOptions} />
                </div>
              </div>
            </li>

            <TextareaAutosize
              maxRows={5}
              value={description !== null ? description : 'Optionally you can click here and add some notes to the band'}
              className={descriptionClassName}
              onClick={() => {
                if (description === null) this.setState({description: ''})
              }}
              onChange={(e) => this.setState({description: e.target.value})}
              onBlur={() => {
                if (!description) this.setState({description: null})
              }} />
          </ul>

          <button ref={this.submit} className="button--primary" type="submit">Send request</button>
        </form>
      </div>
    )
  }
}

EventCreateRiderRequestModal.propTypes = {
  createRiderRequest: PropTypes.func,
  setModal: PropTypes.func
}

EventCreateRiderRequestModal.defaultProps = {
  createRiderRequest: function() {},
  setModal: function() {}
}

export default EventCreateRiderRequestModal



// WEBPACK FOOTER //
// ./src/components/modals/event-create-rider-request-modal.js